module.exports = __webpack_public_path__ + "static/media/ricker.9bb63488.mp4";